import React from "react";
import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Central norsk-språk ordbok for kompliserte forretningsbegrep.
const TERMS = {
  swot: {
    title: "SWOT-analyse",
    body: "Fire perspektiver på virksomheten: Styrker og Svakheter (interne forhold) + Muligheter og Trusler (eksterne forhold). Hjelper deg å se hva du kan bygge på og hva du må håndtere.",
  },
  kpi: {
    title: "KPI (Nøkkeltall)",
    body: "Key Performance Indicator - målbare tall som viser om du er på vei mot målene dine. Eksempler: omsetning, antall kunder, konverteringsrate.",
  },
  tam: {
    title: "TAM",
    body: "Total Addressable Market - hele det potensielle markedet for produktet ditt, uansett geografi eller konkurranse.",
  },
  sam: {
    title: "SAM",
    body: "Serviceable Addressable Market - den delen av TAM du realistisk kan nå, gitt bransje, geografi og forretningsmodell.",
  },
  som: {
    title: "SOM",
    body: "Serviceable Obtainable Market - andelen av SAM du realistisk kan vinne innen kort tid, gitt konkurranse og kapasitet.",
  },
  breakeven: {
    title: "Break-even",
    body: "Punktet der inntektene dine dekker alle kostnader. Etter dette går bedriften i pluss. Måles ofte i antall måneder etter oppstart.",
  },
  arpu: {
    title: "ARPU",
    body: "Average Revenue Per User - gjennomsnittlig omsetning per betalende bruker. Nyttig for å vurdere om prisen din er riktig.",
  },
  konvertering: {
    title: "Konvertering",
    body: "Andelen besøkende eller brukere som utfører ønsket handling (f.eks. kjøp). Måles i prosent.",
  },
  enk: {
    title: "ENK (Enkeltmannsforetak)",
    body: "Norsk selskapsform der du er personlig ansvarlig. Enklest å starte, men uten skille mellom deg og bedriften økonomisk.",
  },
  as: {
    title: "AS (Aksjeselskap)",
    body: "Norsk selskapsform med begrenset ansvar. Krever 30 000 kr i aksjekapital og gir tydelig skille mellom deg og bedriften.",
  },
};

export default function Glossary({ term, className = "" }) {
  const key = String(term || "").toLowerCase();
  const entry = TERMS[key];
  if (!entry) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={`inline-flex items-center justify-center text-slate-400 hover:text-slate-700 transition-colors align-middle ${className}`}
          aria-label={`Forklaring: ${entry.title}`}
          data-testid={`glossary-${key}`}
        >
          <Info className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 text-sm" align="start" sideOffset={6}>
        <p className="font-medium text-slate-900">{entry.title}</p>
        <p className="mt-1.5 text-slate-600 leading-relaxed">{entry.body}</p>
      </PopoverContent>
    </Popover>
  );
}

export { TERMS };
